var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "93.000000pt",
    height: "94.000000pt",
    viewBox: "0 0 93.000000 94.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,94.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285 815 c-99 -36 -189 -69 -200 -74 l-21 -9 31 -263 30 -264 169 -94 169 -95 91 49 c50 27 127 69 171 94 l80 46 31 260 c17 143 28 263 24 267 -3 4 -87 37 -185 72 -99 35 -187 67 -195 70 -8 3 -96 -24 -195 -59z m310 -322 c63 -141 115 -261 115 -265 0 -4 -20 -8 -44 -8 l-44 0 -25 63 -25 62 -107 0 -107 0 -25 -62 -25 -63 -48 0 -47 0 125 281 c91 203 128 276 134 265 5 -9 60 -131 123 -273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432 518 c-18 -42 -32 -81 -32 -87 0 -7 26 -11 66 -11 l66 0 -6 26 c-4 14 -19 54 -35 88 l-27 61 -32 -77z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.de6146d781dfc70dc855518e19adde3d.svg";
export { ForwardRef as ReactComponent };